// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__gPBtM","links":"Navbar_links__z1dfm","footer":"Navbar_footer__-P8HP"};